var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntroHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8374_15559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "terms-icon",
    d: "M18.3643 10.98C19.9263 12.541 19.9263 15.074 18.3643 16.636L12.7073 22.293C12.3173 22.683 11.6833 22.683 11.2933 22.293L5.63634 16.636C4.07434 15.074 4.07434 12.541 5.63634 10.979C7.19834 9.417 9.73134 9.417 11.2933 10.979L11.9993 11.686L12.7073 10.979C14.2693 9.417 16.8023 9.417 18.3643 10.979V10.98ZM7.05034 12.392C6.27034 13.173 6.27034 14.44 7.05034 15.221L12.0003 20.171L16.9503 15.221C17.7303 14.44 17.7303 13.173 16.9503 12.392C16.1693 11.612 14.9023 11.612 14.1203 12.394L11.9983 14.512L9.87834 12.392C9.09834 11.612 7.83134 11.612 7.05034 12.392ZM12.0003 1C14.2103 1 16.0003 2.79 16.0003 5C16.0003 7.21 14.2103 9 12.0003 9C9.79034 9 8.00034 7.21 8.00034 5C8.00034 2.79 9.79034 1 12.0003 1ZM12.0003 3C10.8953 3 10.0003 3.895 10.0003 5C10.0003 6.105 10.8953 7 12.0003 7C13.1053 7 14.0003 6.105 14.0003 5C14.0003 3.895 13.1053 3 12.0003 3Z",
    fill: "#2262ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8374_15559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroHeartIcon);
export default __webpack_public_path__ + "static/media/intro_heart_icon.37d59a374b2ec10cb5d510a7c5db24bd.svg";
export { ForwardRef as ReactComponent };